export { default } from './LoanTag';
